<div class="ui-drawer-inner-container" #content>
  <ng-content />
</div>
